import { useEffect, useState } from "react";
import {
  ButtonPasswordIcon,
  CloseButtonModel,
  ContainerIncludeValidation,
  ContainerInput,
  ContainerInputPassword,
  ErrorTextUser,
  IndicatorPassword,
  SignUpHeader,
  SignUpListItem,
  SignUpModelContainer,
  SignUpTitle,
  SubmitFormButton,
  TextInput,
} from "./SignUpModelStyles.styled";
import { FormErrorsSignUp } from "../TypeErrors";
import { signUp } from "../../../../../Redux/Auth/operations";
import { useAppDispatch } from "../../../../../Redux/store";
import { useNavigate } from "react-router";
import { useTogglePassword } from "../../../../secure/PasswordHook";
import { CloseButtonIcon, EmailUserIcon, UserIcon } from "./setPublicIcons";
import { useLanguageContext } from "../../../../Languages/Langs/LanguageContext";
import { Checkboxs } from "./Checkboxs/Checkboxs";

interface SignUpModelProps {
  onClose: () => void;
}

// fix error, if user already signed up with (nameuser) []
// add reCAPTCHA []

export const SignUpModel: React.FC<SignUpModelProps> = ({ onClose }) => {
  const { t } = useLanguageContext();
  const router = useNavigate();
  const [nameUserSignUp, setNameSignUp] = useState(() => {
    const saved = localStorage.getItem("form-data");
    return saved ? JSON.parse(saved).name || "" : "";
  });

  const [emailUserSignUp, setEmailUserSignUp] = useState(() => {
    const saved = localStorage.getItem("form-data");
    return saved ? JSON.parse(saved).email || "" : "";
  });

  const [passwordUserSignUp, setPasswordUserSignUp] = useState("");
  const [confirmPasswordUserSignUp, setConfirmPasswordUserSignUp] =
    useState("");
  const [formErrorsSignUp, setFormErrorsSignUp] = useState<FormErrorsSignUp>(
    {}
  );
  const dispatch = useAppDispatch();

  const enterPassword = useTogglePassword();
  const repeatPasswordToggle = useTogglePassword();

  const [hasTriedSubmit, setHasTriedSubmit] = useState<boolean>(false);

  interface PasswordStrength {
    label: string;
    value: number;
    color: string;
  }
  const [strength, setStrength] = useState<PasswordStrength | null>(null);

  const evaluatePasswordStrength = (password: string) => {
    let score = 0;

    if (password.length >= 8) score++;
    if (password.length >= 12) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    if (score <= 2) {
      return {
        label: t("passwordInducator.strengthWeak"),
        value: 25,
        color: "#ff4d4d",
      }; // red
    }

    if (score <= 4) {
      return {
        label: t("passwordInducator.strengthMedium"),
        value: 50,
        color: "#ffa600",
      }; // orange
    }

    if (score === 5) {
      return {
        label: t("passwordInducator.strengthStrong"),
        value: 75,
        color: "#0099ff",
      }; // blue
    }

    return {
      label: t("passwordInducator.strengthStronger"),
      value: 100,
      color: "#00cc66",
    }; // green
  };

  const getBoolean = (fd: FormData, key: string) => fd.get(key) === "on";

  const SignUpUser = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setHasTriedSubmit(true);

    const form = evt.currentTarget;
    const formData = new FormData(form);
    const name = formData.get("name") as string;
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;
    const confirmPassword = formData.get("confirmPassword") as string;
    const ageRating = getBoolean(formData, "ageRating");
    const policyPrivacy = getBoolean(formData, "policyPrivacy");

    const formDataUser = {
      name: nameUserSignUp.trim(),
      email: emailUserSignUp.trim(),
    };

    localStorage.setItem("form-data", JSON.stringify(formDataUser));

    try {
      const signUpUser = await dispatch(
        signUp({
          name,
          email,
          password,
          confirmPassword,
          ageRating,
          policyPrivacy,
        })
      ).unwrap();

      router(`/home-page/${signUpUser?.name?.toLowerCase()}`, {
        state: { openConfirmEmailModal: true },
      });
      onClose();
      clearLocalStorage("form-data");
    } catch (err: unknown) {
      console.log(err);
      if (typeof err === "object" && err !== null) {
        setFormErrorsSignUp(err as FormErrorsSignUp);
      }
    }
  };

  const clearLocalStorage = (nameKey: string) => {
    localStorage.removeItem(nameKey);
  };

  useEffect(() => {
    const formData = {
      name: nameUserSignUp.trim(),
      email: emailUserSignUp.trim(),
    };

    localStorage.setItem("form-data", JSON.stringify(formData));

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflowY = "scroll";
    };
  }, [nameUserSignUp, emailUserSignUp, onClose]);

  return (
    <>
      <SignUpModelContainer>
        <SignUpHeader>
          <SignUpTitle>
            {t("publicTranslate.FormsAndModel.ModelSignUp.Title")}
          </SignUpTitle>
          <CloseButtonModel type="button" onClick={onClose}>
            <CloseButtonIcon />
          </CloseButtonModel>
        </SignUpHeader>

        <form onSubmit={SignUpUser}>
          <ul>
            <SignUpListItem>
              <ContainerInput
                className={
                  formErrorsSignUp.name && hasTriedSubmit
                    ? "error-animation-input"
                    : ""
                }
              >
                <TextInput
                  onChange={(evt) => {
                    const value = evt.target.value;
                    setNameSignUp(value);

                    setFormErrorsSignUp((prev) => ({
                      ...prev,
                      name: value ? "" : prev.name, // ← ОНОВЛЮЄМО ПРАВИЛЬНЕ ПОЛЕ
                    }));
                  }}
                  type="text"
                  name="name"
                  placeholder={t(
                    "publicTranslate.FormsAndModel.ModelSignUp.InputName"
                  )}
                  value={nameUserSignUp}
                />
                <UserIcon />
              </ContainerInput>
              <ErrorTextUser
                className={
                  formErrorsSignUp.name && hasTriedSubmit
                    ? "error-animation"
                    : ""
                }
              >
                {formErrorsSignUp.name}
              </ErrorTextUser>
              <ErrorTextUser
                className={
                  formErrorsSignUp.nameUser && hasTriedSubmit
                    ? "error-animation"
                    : ""
                }
              >
                {formErrorsSignUp.nameUser}
              </ErrorTextUser>
            </SignUpListItem>
            <SignUpListItem>
              <ContainerInput
                className={
                  formErrorsSignUp.email && hasTriedSubmit
                    ? "error-animation-input"
                    : ""
                }
              >
                <TextInput
                  onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                    const value = evt.target.value;
                    setEmailUserSignUp(value);
                    setFormErrorsSignUp((prev) => ({
                      ...prev,
                      email: value ? "" : prev.email,
                    }));
                  }}
                  type="email"
                  name="email"
                  placeholder={t(
                    "publicTranslate.FormsAndModel.ModelSignUp.InputEmail"
                  )}
                  value={emailUserSignUp}
                />
                <EmailUserIcon />
              </ContainerInput>
              <ErrorTextUser
                className={
                  formErrorsSignUp.email && hasTriedSubmit
                    ? "error-animation"
                    : ""
                }
              >
                {formErrorsSignUp.email}
              </ErrorTextUser>
            </SignUpListItem>
            <SignUpListItem>
              <ContainerInput
                className={
                  formErrorsSignUp.password && hasTriedSubmit
                    ? "error-animation-input"
                    : ""
                }
              >
                <TextInput
                  onChange={(evt) => {
                    const value = evt.target.value;
                    setPasswordUserSignUp(value);

                    if (!value) {
                      setStrength(null); // ✅ повертаємо білу смужку
                      return;
                    }

                    const strengthValue = evaluatePasswordStrength(value);
                    setStrength(strengthValue);

                    setFormErrorsSignUp((prev) => ({ ...prev, password: "" }));
                  }}
                  type={enterPassword.type}
                  name="password"
                  placeholder={t(
                    "publicTranslate.FormsAndModel.ModelSignUp.InputPassword"
                  )}
                  value={passwordUserSignUp}
                />
                <ButtonPasswordIcon
                  type="button"
                  onClick={enterPassword.toggle}
                >
                  {enterPassword.icon}
                </ButtonPasswordIcon>
              </ContainerInput>
              <ErrorTextUser
                className={
                  formErrorsSignUp.password && hasTriedSubmit
                    ? "error-animation"
                    : ""
                }
              >
                {formErrorsSignUp.password}
              </ErrorTextUser>
            </SignUpListItem>
          </ul>

          <ContainerIncludeValidation>
            <IndicatorPassword
              width={strength?.value || 0}
              color={strength?.color || "#fff"}
            ></IndicatorPassword>
            <span>{strength?.label || ""}</span>
            <span>
              {t(
                "publicTranslate.FormsAndModel.ModelSignUp.RecommendationText"
              )}{" "}
              {t(
                "publicTranslate.FormsAndModel.ModelSignUp.RecomendationTitle"
              )}
            </span>
          </ContainerIncludeValidation>

          <ContainerInputPassword
            className={
              formErrorsSignUp.confirmPassword && hasTriedSubmit
                ? "error-animation-input"
                : ""
            }
          >
            <TextInput
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                const value = evt.target.value;
                setConfirmPasswordUserSignUp(value);
                setFormErrorsSignUp((prev) => ({
                  ...prev,
                  confirmPassword: value ? "" : prev.confirmPassword,
                }));
              }}
              type={repeatPasswordToggle.type}
              name="confirmPassword"
              placeholder={t(
                "publicTranslate.FormsAndModel.ModelSignUp.InputConfirmPassword"
              )}
              value={confirmPasswordUserSignUp}
            />
            <ButtonPasswordIcon
              type="button"
              onClick={repeatPasswordToggle.toggle}
            >
              {repeatPasswordToggle.icon}
            </ButtonPasswordIcon>
          </ContainerInputPassword>
          <ErrorTextUser
            className={
              formErrorsSignUp.confirmPassword && hasTriedSubmit
                ? "error-animation"
                : ""
            }
          >
            {formErrorsSignUp.confirmPassword}
          </ErrorTextUser>
          <Checkboxs
            submitForm={hasTriedSubmit}
            formErrorsSignUp={formErrorsSignUp}
          />
          <SubmitFormButton
            type="submit"
            value={t("publicTranslate.FormsAndModel.ModelSignUp.ButtonSignUp")}
          />
        </form>
      </SignUpModelContainer>
    </>
  );
};
